module.exports = __webpack_public_path__ + "img/ta-ny-leftTitleBg02.8fed92d6.png";